import { render, staticRenderFns } from "./dashboard-card.vue?vue&type=template&id=4a30cdf4&scoped=true&"
import script from "./dashboard-card.vue?vue&type=script&lang=js&"
export * from "./dashboard-card.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-card.vue?vue&type=style&index=0&id=4a30cdf4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a30cdf4",
  null
  
)

export default component.exports